<script>
import { required } from "vuelidate/lib/validators";
import { cloneDeep } from "lodash";

export default {
    name: "DeliveryUnitServiceModal",
    props: {
        dus: Array,
        duLoading: Boolean,
        fsLoading: Boolean,
        fundClusters: Array,
        fundSources: Array,
        modalTitle: String
    },
    data(){
        return {
            form: {
                id: 0,
                serviceName: "",
                deliveryUnitId: null,
                fundSourceId: null,
                fundClusterId: null,
                useMeterReading: false,
            },
            submitted: false,
        }
    },
    validations: {
        form: {
            serviceName: { required },
            deliveryUnitId: { required },
            fundSourceId: { required },
            fundClusterId: { required },
        },
    },
    methods: {
        updateData(data){
            this.form = cloneDeep(data)
        },
        resetForm(){
            this.form = {
                id: 0,
                serviceName: "",
                deliveryUnitId: null,
                fundSourceId: null,
                fundClusterId: null,
                useMeterReading: false,
            }
            this.submitted = false;
            this.$v.$reset();
        },
        submitForm(){
            this.submitted = true;
            this.$v.form.$touch();
            if(this.$v.form.$invalid) return;
            let data = cloneDeep(this.form);
            this.$emit('submit', data);
        },
    }
};
</script>
<template>
  <b-modal
    id="du-service-modal"
    :title="modalTitle"
    size="md"
    title-class="font-18"
    hide-footer
    no-close-on-backdrop
  >
    <form  @submit.prevent="submitForm">
        <div class="mb-3">
            <label for="serviceName">Service Name</label>
            <input 
                autocomplete="off"
                id="serviceName"
                type="text" 
                class="form-control" 
                v-model="form.serviceName" 
                :class="{'is-invalid': submitted && $v.form.serviceName.$error}"

            />
            <div 
                v-if="submitted && $v.form.serviceName.$error"
                class="invalid-feedback"
            >
                <span v-if="!$v.form.serviceName.required">Service name is required.</span>
            </div>
        </div>
        <div class="mb-3">
            <label for="deliveryUnit">Delivery Unit</label>
            <template v-if="duLoading">Loading...</template>
            <template v-else>
                <select 
                    id="deliveryUnit" 
                    class="form-select"
                    v-model="form.deliveryUnitId"
                    :class="{'is-invalid': submitted && $v.form.deliveryUnitId.$error}"
                >
                    <option>Select Delivery Unit</option>
                    <option v-for="du in dus" :key="du.id" :value="du.id">{{ du.name }}</option>
                </select>
            </template>
        </div>
        <div class="mb-3">
            <label for="fundCluster">Fund Cluster</label>
            <select 
                id="fundCluster" 
                class="form-select"
                :class="{'is-invalid': submitted && $v.form.fundClusterId.$error}"
                v-model="form.fundClusterId"
                @change="$emit('getFS', form.fundClusterId)"
                
            >
                <option>Select Fund Cluster</option>
                <option v-for="cluster in fundClusters" :key="cluster.id" :value="cluster.id">{{ cluster.cluster }}</option>
            </select>
        </div>
        <div class="mb-3" v-if="form.fundClusterId">
            <label for="foundSource">Fund Source</label>
            <template v-if="fsLoading">Loading...</template>
            <template v-else>
                <select 
                    id="foundSource" 
                    class="form-select"
                    :class="{'is-invalid': submitted && $v.form.fundSourceId.$error}"
                    v-model="form.fundSourceId"
                >
                    <option>Select Fund Cluster</option>
                    <option v-for="fund in fundSources" :key="fund.id" :value="fund.id">{{ fund.sourceName }}</option>
                </select>
            </template>
        </div>
        <div class="form-check form-checkbox-outline form-check-success mb-3">
            <input
                type="checkbox"
                :id="`meterReading`"
                class="form-check-input"
                v-model="form.useMeterReading"
            />
            <label
                :for="`meterReading`"
                class="form-check-label no-wrap"
            >
                Has Meter Reading
            </label>
        </div>
        <template v-if="form.useMeterReading">
            <div class="mb-3">
                <label for="unit">Unit</label>
                <input 
                    autocomplete="off"
                    id="unit"
                    type="text" 
                    class="form-control" 
                    v-model="form.unit" 
                />
            </div>
        </template>
        <div class="modal-footer">
            <button type="submit" class="btn btn-primary"><i class="bx bx-save"></i>{{ form.id != 0 ? "Update" : "Save" }}</button>
            <button type="button" class="btn btn-link" @click="$bvModal.hide('du-service-modal')">Close</button>
        </div>
    </form>
  </b-modal>
</template>